import { render, staticRenderFns } from "./NAO_Cruceros.vue?vue&type=template&id=20382f2f&scoped=true&"
import script from "./NAO_Cruceros.vue?vue&type=script&lang=js&"
export * from "./NAO_Cruceros.vue?vue&type=script&lang=js&"
import style0 from "./NAO_Cruceros.vue?vue&type=style&index=0&id=20382f2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20382f2f",
  null
  
)

export default component.exports